define('pages/player/player_form_page_view',[
  'backbone',
  'jquery',
  '_',

  'modules/player/player_form_view',

  'text!./player_form_page_template.html',
], function (Backbone, $, _, PlayerFormView, player_form_page_template) {
  'use strict';
  var View = Backbone.View.extend({
    initialize: function (options) {
      this.subViews = [];

      this.player_form = new PlayerFormView({ player_id: options.player_id });
      this.subViews.push(this.player_form);

      this.player_id = options.player_id;
      this.zone_id = options.params.zone_id;
      this.player_name = options.params.player_name;

      this.listenTo(
        this.player_form.formModel,
        'change',
        function (model) {
          var playerName = model.get('title') || this.player_name;
          $('.page-title p').text(playerName);
        },
        this
      );

      this.render();

      this.renderSubView();
    },

    template: _.template(player_form_page_template),
    subViews: [],

    render: function () {
      this.$el.html(
        this.template({
          player_name: this.player_name,
          player_id: this.player_id,
          zone_id: this.zone_id,
        })
      );

      return this;
    },

    renderSubView: function () {
      this.$('.player-form-page-content').html(this.player_form.$el);
    },

    remove: function () {
      _.each(this.subViews, function (view) {
        if (view && view.remove) {
          view.remove();
        }
      });
      this.$el.off();
      this.$el.empty();
      this.stopListening();
      return this;
    },
  });
  return View;
});

